<template>
	<div class="tracking-content">
		<feather-icon
			class="ml-4 cursor-pointer"
			icon="SmartphoneIcon"
			@click="popupActive = true"
			:title="$t('MapModule.software_details')"
		/>
		<vs-popup :title="$t('MapModule.software_details')" :active.sync="popupActive">
			<vx-card class="text-center cursor-pointer" no-shadow>
				<img :src="logo" alt="graphic" width="70" class="mx-auto mb-2" />
				<h4>{{ tracking.version ? tracking.version : $t("MapModule.no_transmission") | title }}</h4>
				<small class="font-semibold">{{ $t("MapModule.mobile_app_version") }}</small>

				<template slot="footer">
					<vs-divider />
					<div class="flex justify-between mb-1">
						<span class="flex items-center">
							<feather-icon icon="UserIcon" svgClasses="h-5 w-5 stroke-current" />
							<span class="ml-2">{{ $t("Username") }}</span>
						</span>
						<span class="flex items-center">
							<span class="ml-2 font-semibold">{{ tracking.username }}</span>
						</span>
					</div>
					<div class="flex justify-between mb-1">
						<span class="flex items-center">
							<feather-icon icon="SmartphoneIcon" svgClasses="h-5 w-5 stroke-current" />
							<span class="ml-2">{{ $t("MapModule.android_os_version") }}: </span>
						</span>
						<span class="flex items-center">
							<span class="ml-2">{{
								tracking.version_os ? tracking.version_os : $t("MapModule.no_transmission") | title
							}}</span>
						</span>
					</div>
					<div class="flex justify-between mb-1">
						<span class="flex items-center">
							<feather-icon icon="CalendarIcon" svgClasses="h-5 w-5 stroke-current" />
							<span class="ml-2">{{ $t("Date") }}</span>
						</span>
						<span class="flex items-center">
							<span class="ml-2">{{
								tracking.date ? tracking.date : $t("MapModule.no_transmission") | title
							}}</span>
						</span>
					</div>
				</template>
			</vx-card>
		</vs-popup>
	</div>
</template>

<script>
export default {
	props: {
		tracking: {
			type: Object,
		},
	},
	data() {
		return {
			popupActive: false,
			logo: require("@/assets/images/pages/rutify/1-03.png"),
		};
	},
};
</script>

<style lang="scss" scoped>
.tracking-content {
	display: contents;
}
</style>
